const CENTRAL_HOSTS = new Set([
  "central.wehonor.app",
  "monarchcentral.localhost",
  "monarchcentral.web.app",
  "monarchcentral.firebaseapp.com",
]);

export const CENTRAL_APP_URL = "https://central.wehonor.app/";
export const CENTRAL_NOTIFICATION_ORIGINS = new Set([new URL(CENTRAL_APP_URL).origin, "https://monarchcentral.web.app", "https://monarchcentral.firebaseapp.com"]);
/** Existing canonical family intake origin; keep public memorial use limited to this start route. */
export const ARRANGEMENT_PLANNER_START_URL = "https://arrangementstudio.web.app/start";

export function isCentralHostname(hostname: string) {
  const normalized = hostname.toLowerCase();
  return (
    CENTRAL_HOSTS.has(normalized) ||
    (normalized.startsWith("monarchcentral--") && normalized.endsWith(".web.app"))
  );
}

function cleanWorkspaceAlias(path: string) {
  if (path === "/workspace/events") return "/events";
  if (path === "/workspace/registry") return "/registry";
  return path;
}

function cleanLegacyStaffNamespace(path: string, namespace: "/admin" | "/director") {
  const cleanPath = path.replace(new RegExp(`^${namespace}`), "") || "/";
  const caseMatch = cleanPath.match(/^\/cases\/([^/?#]+)$/);
  if (caseMatch?.[1]) {
    return `/workspace/case-overview?caseId=${caseMatch[1]}`;
  }
  return cleanWorkspaceAlias(cleanPath);
}

export function cleanStaffPath(path: string) {
  if (path === "/admin" || path === "/director") {
    return "/";
  }

  if (path.startsWith("/admin/")) {
    return cleanLegacyStaffNamespace(path, "/admin");
  }

  if (path.startsWith("/director/")) {
    return cleanLegacyStaffNamespace(path, "/director");
  }

  return cleanWorkspaceAlias(path);
}

const PUBLIC_HOST_PATHS = [
  "/arrangements",
  "/demo",
  "/family",
  "/memorial",
  "/onboarding",
  "/service-folder",
  "/sign",
] as const;

export function isPublicHostPath(pathname: string) {
  if (pathname === "/") return true;
  return PUBLIC_HOST_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}

export function isRetiredMonarchStaffDemoPath(pathname: string) {
  return ["/demo/monarch/staff", "/demo/monarch/director"].some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
